/*🤫
🤫
🤫
🤫
🤫
🤫*/
import { Breakpoint as BreakpointType } from "@otto-ec/global-breakpoint";

export * from "./globals/breakpoint";
/*🤫*/
type Breakpoint = BreakpointType;
/*🤫*/
const { breakpoint, Breakpoint } = window.o_global;

export { breakpoint, Breakpoint };
